<template>
    <v-container fluid class="pa-0">
    <v-card>
        <v-card-title>
            {{$t('event.transport')}}
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddTransport">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :loading="isTransportsPending"
                @pagination="currentPagination"
                :items="tableTransports"
                >
                <template v-slot:item.title="{value}">
                    {{value}}
                </template>
                <template v-slot:item.isVip="{value}">
                    {{value}}
                </template>
                <template v-slot:item.scroller="{value}">
                    <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                    <div v-show="!isEditOrderMode"></div>
                </template>
                <template v-slot:item.items="{item,value}">
                    {{getLength(item)}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode"
                        @click="initEditTransport(item)">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                        @click="deleteTransport(item)">
                        {{$t('delete')}}
                        <v-icon right>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>

        <v-dialog v-model="showEditTransportDialog"
            persistent
            fullscreen
            hide-overlay
            >
            <v-card id="vCard">
                <v-app-bar fixed dark color="primary">
                    <v-btn icon dark @click="closeEditTransport">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span class="app-bar">{{$t('event.transport')}}</span>
                </v-app-bar>
                <v-container class="pt-16">
                    <v-row>
                        <v-col class="py-0 mt-5">
                            <v-text-field outlined
                                        :label="$t('event_transport.title')"
                                        :placeholder="$t('event_transport.title')"
                                        v-model="editingTransportItem.title"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_transport.title_tc')"
                                        :placeholder="$t('event_transport.title_tc')"
                                        v-model="editingTransportItem.title_tc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_transport.title_sc')"
                                        :placeholder="$t('event_transport.title_sc')"
                                        v-model="editingTransportItem.title_sc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_transport.tag')"
                                        :placeholder="$t('event_transport.tag')"
                                        v-model="editingTransportItem.tag"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_transport.is_vip')"
                                        :placeholder="$t('event_transport.is_vip')"
                                        v-model="editingTransportItem.isVip"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_transport.key')"
                                        :placeholder="$t('event_transport.key')"
                                        v-model="editingTransportItem.key"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="justify-end">
                        <v-label v-if="!selectedTransportId">
                            {{'Click save to start adding Transport items'}}
                        </v-label>
                        <div class="saveTransportEditButton"></div>
                        <v-btn color="primary" @click="saveTransportEdit">
                            {{$t('save')}}
                        </v-btn>
                        <div class="saveTransportEditButton"></div>
                    </v-row>
                    <v-row v-if="editingTransportItem && selectedTransportId">
                        <v-col>
                            <EventTransportItemList :transport-id="editingTransportItem.id"></EventTransportItemList>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
    </v-container>
</template>
<style scoped>
    .saveTransportEditButton{
        width:12px;
        height: 50px;
    }
    .button-spacer {
        width:10px;
    }

    .app-bar {
        font-size: 1.25rem; 
        line-height: 1.5; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        margin-left: 20px;
    }

</style>
<script>
    import {computed, ref, watch, onMounted} from '@vue/composition-api'
    import {useGet, useFind} from "feathers-vuex";
    import EventTransportItemList from "./EventTransportItemList";
    import { cloneDeep,differenceWith, difference } from 'lodash';
    import Sortable from "sortablejs";

    export default {
        name: 'EventTransport',
        components: {EventTransportItemList},
        setup(props, {root}) {
            const {Event,EventTransport} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);

            const {item: event, isPending} = useGet({model: Event, id: eventId.value});
            
            const transportParams = computed(()=>{
                return {
                    query:{
                        eventId: eventId.value
                    },
                    $sort:{
                        order: 1
                    }
                }
            })
            const {items: transports, isPending: isTransportsPending} = useFind({
                model: EventTransport,
                params: transportParams,
            })
            
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);
            const editOrderTransports = ref([]);
            const selectedTransportId=ref(null);

            const overlay = ref(false);

            const closeEditTransport = function() {
                showEditTransportDialog.value = false;
                selectedTransportId.value = null
            }
            const headers = ref([
                {text: '',value:'scroller',width:80},
                {text: 'Order',value:'order'},
                {text: 'Title',value:'title'},
                {text: 'VIP',value:'isVip'},
                {text: 'Transport Items',value:'items'},
                {text: '',value:'actions'},
            ])

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };

            const editingTransportItem = ref(new EventTransport({eventId: eventId.value}))
            const showEditTransportDialog = ref(false);

            const initEditTransport = function(transport){
                editingTransportItem.value = transport
                showEditTransportDialog.value = true
                selectedTransportId.value = transport.id
            }
            const initAddTransport = function(){
                showEditTransportDialog.value = true
                editingTransportItem.value = new EventTransport({eventId: eventId.value})
                selectedTransportId.value = null
                console.log(transports.value);
                editingTransportItem.value.order = transports.value.length + 1;
            }

            const deleteTransport = function(item){
                if(confirm(root.$t('event_transport.confirm_delete'))){
                    item.remove().then(()=>{
                        root.$store.dispatch('showSnackBar', root.$t('event_transport.delete_successful'));
                    }, root.$handleFeatherError.bind(root));
                }
            }
            const getLength = function(item){
                return item?(item.items?item.items.length:0):0
            }

            const saveTransportEdit = async function(){
                // if( editingTransportItem.value.banner instanceof File){
                //     editingTransportItem.value.banner = {src:await root.$uploadFile(editingTransportItem.value.banner)};
                // }
                // if( editingTransportItem.value.map instanceof File){
                //     editingTransportItem.value.map = {src:await root.$uploadFile(editingTransportItem.value.map)};
                // }
                editingTransportItem.value.save().then(async (savedTransport)=>{
                    editingTransportItem.value = savedTransport
                    selectedTransportId.value = savedTransport.id
                    root.$store.dispatch('showSnackBar', root.$t('event_transport.save_successful'));
                })

            }
            const initEditOrder = function(){
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderTransports.value = cloneDeep(sortedTransports.value)
            }

            const saveEditOrder =  async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                for(let i=0;i<editOrderTransports.value.length;i++){
                    await editOrderTransports.value[i].save().then(()=>{
                        EventTransport.get(editOrderTransports.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false;
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false
            }
            const quickSortTransports = function(sortTransports){
                if(sortTransports.length<2){
                    return sortTransports
                }

                const chosenIndex = sortTransports.length - 1
                const chosen  = sortTransports[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortTransports[i].order
                    temp < chosen.order ? a.push(sortTransports[i]) : b.push(sortTransports[i])
                }
                const output = [...quickSortTransports(a),chosen,...quickSortTransports(b)]
                return output
            }

            const sortedTransports = computed(()=>{
                return quickSortTransports(transports.value)
            })
            const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            didOrderChange.value = true;
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderTransports.value.splice(oldIndex,1)[0];
                            editOrderTransports.value.splice(newIndex,0,rowSelected);

                            for(let i=0;i<editOrderTransports.value.length;i++){
                                editOrderTransports.value[i].order = i+1
                            }
                            editOrderTransports.value = quickSortTransports(editOrderTransports.value);
                        }
                    }
                )
            });

            watch(showEditTransportDialog, (newVal, oldVal) => {
                if (newVal) {
                    document.getElementById('vCard').scrollIntoView();
                }
            })

            const tableTransports = computed(()=>{
                return isEditOrderMode.value ? editOrderTransports.value : sortedTransports.value
            })

            return {
                headers,
                tableTransports,
                isTransportsPending,
                previewHtmlContentOption,
                isEditOrderMode,
                currentPagination,

                editingTransportItem,
                showEditTransportDialog,
                closeEditTransport,
                initEditTransport,
                initAddTransport,
                selectedTransportId,

                deleteTransport,
                getLength,
                saveTransportEdit,

                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                overlay,
            }
        },
    }
</script>